import CheckListDetail from "./CheckListDetail";

export default CheckListDetail;
